var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "074AE559-2675-40F9-8A3D-AD7256FDA794") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Stakeholders",
    transform: "translate(-878.000000, -537.000000)",
    fill: "#2974C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(878.000000, 537.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,12.4277344 C9.48540234,12.4277344 9.87890625,12.8212383 9.87890625,13.3066406 C9.87890625,13.792043 9.48540234,14.1855469 9,14.1855469 C8.51459766,14.1855469 8.12109375,13.792043 8.12109375,13.3066406 C8.12109375,12.8212383 8.51459766,12.4277344 9,12.4277344",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.59375 C4.80315234,16.59375 1.40625,13.1974102 1.40625,9 C1.40625,4.80315234 4.80258984,1.40625 9,1.40625 C13.1968477,1.40625 16.59375,4.80258984 16.59375,9 C16.59375,13.1968477 13.1974102,16.59375 9,16.59375 M9,0 C4.02595313,0 0,4.02528516 0,9 C0,13.9740469 4.02528516,18 9,18 C13.9740469,18 18,13.9747148 18,9 C18,4.02595313 13.9747148,0 9,0",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4.51757812 C7.4491875,4.51757812 6.1875,5.77926562 6.1875,7.33007812 C6.1875,7.71841406 6.50228906,8.03320312 6.890625,8.03320312 C7.27896094,8.03320312 7.59375,7.71841406 7.59375,7.33007812 C7.59375,6.55467188 8.22459375,5.92382812 9,5.92382812 C9.77540625,5.92382812 10.40625,6.55467188 10.40625,7.33007812 C10.40625,8.10548437 9.77540625,8.73632812 9,8.73632812 C8.61166406,8.73632812 8.296875,9.05111719 8.296875,9.43945312 L8.296875,11.1972656 C8.296875,11.5856016 8.61166406,11.9003906 9,11.9003906 C9.38833594,11.9003906 9.703125,11.5856016 9.703125,11.1972656 L9.703125,10.0535977 C10.9148203,9.74060156 11.8125,8.63820703 11.8125,7.33007812 C11.8125,5.77926562 10.5508125,4.51757812 9,4.51757812",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f17b8409.svg";
export { ForwardRef as ReactComponent };